module.exports = __webpack_public_path__ + "img/translate.235cd0fe.svg";